var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-body"},[_c('p',[_vm._v(_vm._s(_vm.text))]),_c('font-awesome-icon',{staticClass:"loading-icon",attrs:{"icon":['fas', 'cog']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }